export const getSessionToken = () => {
  return window.localStorage.getItem('sessionToken');
}

export const setSessionToken = (token) => {
  return window.localStorage.setItem('sessionToken', token);
}
